export enum TabType {
  RUNNING = 'running',
  WAITING = 'waiting',
  TEAM = 'team',
  USER = 'user',
  FISINHED = 'finished',
  ALL = 'all',
}

export interface ChatTabState {
  selected: {
    type: TabType,
    entityId?: string,
  };
}

export const ChatTabModule = {
  state: {
    selected: {
      type: TabType.RUNNING,
      entityId: '',
    },
  },
  mutations: {
    setSelectedTab(state: ChatTabState, tab: { type: TabType, entityId?: string }) {
      state.selected = tab;
    },
  },
  actions: {
    async loadChatTab(context: any, tab: { type: TabType, entityId: any }) {
      context.commit('setSelectedTab', tab);
      context.dispatch('loadChatsByTab', tab);
    },
  },
};
